import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  flex: {
    display: "flex",
  },
  flexWrap: {
    flexWrap: "wrap",
  },
  flexCol: {
    flexDirection: "column",
  },
  spaceBw: {
    justifyContent: "space-between",
  },
  justifyCenter: {
    justifyContent: "center",
  },
  justifyEnd: {
    justifyContent: "end",
  },
  alignCenter: {
    alignItems: "center",
  },
  alignStart: {
    alignItems: "start",
  },
  alignEnd: {
    alignItems: "end",
  },
  textCenter: {
    textAlign: "center",
  },
  // list venue css

  // web view new css

  ctaTwo: {
    fontWeight: "700",
    fontSize: "18px",
    color: "#fff",
    lineHeight: "18px",
    letterSpacing: "0.4px",
    backgroundColor: "#ff4e00",
    padding: "12px 24px",
    borderRadius: "20px",
  },
  carouselArea: {
    "& .control-dots": {
      margin: "8px 0 !important",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      display: "none !important",
      "& li": {
        background: "#000 !important",
        opacity: "1 !important",
        outline: "none",
        boxShadow: "none !important",
        height: "6px !important",
        width: "6px !important",
        margin: "0 3px !important",
        display: "none !important",
      },
      "& li.selected": {
        background: "#000 !important",
        height: "6px !important",
        width: "24px !important",
        borderRadius: "10px",
        display: "none !important",
      },
    },
  },
  carouselBannerDiv: {
    display: "block",
    width: "100%",
    backgroundColor: "#e6a71e",
    padding: "16px",
  },
  carouselContainer: {
    overflowX: "auto",
    scrollSnapType: "x mandatory",
    scrollBehavior: "smooth",
    WebkitOverflowScrolling: "touch",
    width: "100%",
    maxWidth: "520px",
    marginLeft: "16px",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  carouselTrack: {
    display: "flex",
    gap: "20px",
    scrollSnapType: "x mandatory",
  },
  pickleCard: {
    flex: "0 0 80%",
    backgroundColor: "white",
    scrollSnapAlign: "start",
    borderRadius: "20px",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
    border: "2px solid #f2500b",
    cursor: "default",
  },
  reviewCard: {
    flex: "0 0 35%",
    marginRight: "24px",
    "@media (max-width: 1250px)": {
      flex: "0 0 45%",
    },
  },
  cardHeader: {
    backgroundColor: "#f2500b",
    padding: "16px 20px",
    borderTopLeftRadius: "18px",
    borderTopRightRadius: "18px",
  },
  cardTopText: {
    margin: 0,
    fontSize: "22px",
    fontWeight: "bold",
    color: "#fff",
  },
  cardParaText: {
    margin: "4px 0 0",
    fontSize: "16px",
    color: "#fff",
  },
  cardBody: {
    padding: "20px",
    fontSize: "16px",
    lineHeight: "24px",
    color: "#333",
    fontWeight: "500",
  },
  carouselDots: {
    display: "flex",
    justifyContent: "center",
    gap: "8px",
    margin: "24px 0px",
  },
  dot: {
    width: "10px",
    height: "10px",
    backgroundColor: "#ccc",
    borderRadius: "50%",
    transition: "background-color 0.3s ease",
  },
  activeDot: {
    backgroundColor: "#ff4e00",
  },
  w100: {
    width: "100%",
  },
  mT16: {
    marginTop: "16px",
  },
  hrLine: {
    backgroundColor: "#424242",
    height: "1px",
  },
  mainContainer: {
    // maxWidth: "550px",
    position: "relative",
  },
  kmImage: {
    // width: "112px",
    height: "38px",
    verticalAlign: "middle",
    objectFit: "contain",
  },
  downShadow: {
    width: "100%",
    position: "fixed",
    top: "0px",
    backgroundColor: "#fff",
    zIndex: "99999",
    padding: "48px 120px 16px 120px",
  },
  verLine: {
    width: "36px",
    rotate: "90deg",
    border: "1px solid #ff4e00",
  },
  acrossCity: {
    fontSize: "22px",
    lineHeight: "28px",
    fontWeight: "700",
    color: "#424242",
    letterSpacing: "0.25px",
  },
  scrollCard: {
    display: "flex",
    overflowX: "auto",
    scrollBehavior: "smooth",
    msOverflowStyle: "none",
    scrollbarWidth: "none",
    // paddingBottom: "16px",
  },
  shadowCard: {
    boxShadow: "4px 4px 4.3px 0px #3131313B",
    width: "210px",
    borderRadius: "16px",
    padding: "16px",
    flexShrink: 0,
    marginRight: "24px",
  },
  flexContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "24px",
    padding: "32px 0",
  },

  topRow: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "24px",
    width: "100%",
  },
  bottomRow: {
    display: "flex",
    justifyContent: "center",
    gap: "24px",
    width: "100%",
  },
  card: {
    background: "#fff",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    padding: "24px",
    textAlign: "center",
    maxWidth: "360px",
    flex: "1 1 210px",
  },
  cardHeading: {
    fontSize: "20px",
    color: "#ff4e00",
    lineHeight: "24px",
    letterSpacing: "0.25px",
    fontWeight: "700",
    marginBottom: "12px",
  },
  cardPara: {
    fontSize: "18px",
    color: "#424242",
    lineHeight: "26px",
    letterSpacing: "0.1px",
    fontWeight: "400",
  },
  topHeading: {
    fontSize: "32px",
    color: "#424242",
    lineHeight: "38px",
    letterSpacing: "0.25px",
    fontWeight: "700",
    display: "inline-block",
    // fontFamily: "Roboto",
  },
  talkText: {
    fontSize: 20,
    lineHeight: "28px",
  },
  callCta: {
    backgroundColor: "#fff",
    border: "1px solid #ff4e00",
    color: "#424242",
  },
  carouselText: {
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "18px",
    color: "#000",
    letterSpacing: "0.1px",
  },
  topText: {
    color: "#fff",
    textTransform: "uppercase",
    fontSize: "26px",
    fontWeight: "700",
    lineHeight: "30px",
  },
  form: {
    maxWidth: "550px",
  },
  orangeBg: {
    background: "#FF4E00",
  },
  disabled: {
    background: "#BDBDBD",
    cursor: "initial",
  },
  doneIcon: {
    " & svg": {
      width: "28px",
      height: "28px",
      "& path": {
        fill: "green",
      },
    },
  },
  participantInput: {
    display: "flex",
    width: "100%",
    fontWeight: 600,
    fontSize: 15,
    height: "36px",
    padding: "16px",
    alignItems: "center",
    flexShrink: 0,
    borderRadius: "15px",
    outline: "none",
    // borderBottom: "1px solid rgba(255, 78, 0, 0.6)",
    borderBottom: "1px solid #424242",
    border: "none",
    margin: "16px auto",
    color: "#333",
    borderRadius: "inherit",
    "&::placeholder": {
      color: "#ff4e00",
      fontWeight: 700,
      fontSize: 14,
    },
  },
  finalBox2: {
    height: "72px",
    background: "#FFF",
    display: "flex",
    alignItems: "center",
  },
  finalBtn2: {
    // width: "100%",
    borderRadius: "12px",
    background: "#FF4E00",
  },
  finalButton2: {
    display: "block",
    // width: "100%",
    height: "48px",
    padding: "16px 76px",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    borderRadius: "12px",
    fontWeight: "700",
    color: "white",
    fontSize: "15px",
    lineHeight: "16px",
  },
  topTextTwo: {
    color: "#ccc",
    fontSize: "16px !important",
  },
  drawerAutoHeight2: {
    height: "auto !important",
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    margin: "0px auto",
  },
  drawerBodyHeight2: {
    height: "auto !important",
    overflow: "hidden",
    padding: "16px",
  },
  faqDetail: {
    // margin: "16px",
  },
  mB0: {
    marginBottom: "0px",
  },
  mb16: {
    marginBottom: "16px",
  },
  mB10: {
    marginBottom: "10px",
  },
  mT40: {
    marginTop: "40px",
  },
  mB40: {
    marginBottom: "40px",
  },
  pB0: {
    paddingBottom: 0,
  },
  faq: {
    marginBottom: "2px",
  },
  seeAll: {
    display: "flex",
    justifyContent: "center",
    position: "relative",
    bottom: "-6px",
    cursor: "pointer",
    "& svg": {
      width: "18px",
      height: "18px",
      "& path": {
        fill: "#ccc",
      },
    },
  },
  rotate: {
    rotate: "180deg",
  },
  mbZero: {
    marginBottom: 0,
  },
  faqHead: {
    fontWeight: 700,
    fontSize: "24px",
    lineHeight: "32px",
    letterSpacing: "0.25px",
    color: "#ff4e00",
    marginBottom: "8px",
  },
  faqPara: {
    fontWeight: 500,
    fontSize: "20px",
    lineHeight: "28px",
    color: "#424242",
  },
  circle: {
    display: "inline-block",
    width: "34px",
    height: "34px",
    backgroundColor: "#424242",
    borderRadius: "50%",
    margin: "0 auto",
    position: "absolute",
    bottom: 16,
    cursor: "pointer",
  },
  faqLine: {
    width: 118,
    margin: "8px 0px",
  },
  innerBtn: {
    fontSize: "20px",
    fontWeight: "700",
    padding: "15px 30px",
  },
  cross: {
    position: "relative",
    top: "-10px",
    right: "-20px",
  },
  call: {
    fontWeight: "700",
    fontSize: "12px",
    lineHeight: "12px",
    letterSpacing: "0.4px",
    textTransform: "uppercase",
    color: "#19A3FF",
  },
  areaHeight: {
    height: 64,
  },
  listStyle: {
    listStyle: "disc",
    marginLeft: "24px",
  },
  faqList: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "0px",
    listStyleType: "none",
    padding: 0,
    margin: 0,
    [theme.breakpoints.up("sm")]: {
      gridTemplateColumns: "1fr 1fr",
    },
  },
  eventImg: {
    width: "100%",
    height: "620px",
    objectFit: "contain",
  },
  eventOne: {
    position: "relative",
    right: "20%",
  },
  eventTwo: {
    position: "relative",
    left: "30%",
    bottom: "10px",
  },
  eventThree: {
    position: "relative",
    right: "10%",
    marginTop: "24px",
  },
  eventFour: {
    position: "relative",
    right: "-5%",
    marginTop: "24px",
  },
  eventFive: {
    position: "relative",
    right: "15%",
  },
  eventSix: {
    position: "relative",
    right: "-10%",
  },
  evText: {
    fontSize: "32px !important",
    lineHeight: "38px",
    color: "#ff4e00",
    fontWeight: "700",
    letterSpacing: "0.2px",
  },
  evOne: {
    position: "relative",
    left: "60%",
    top: "-50px",
  },
  evTwo: {
    position: "relative",
    right: "55%",
    top: "-60px",
  },
  handle: {
    fontSize: "20px",
    lineHeight: "28px",
    fontWeight: "500",
    color: "#424242",
    letterSpacing: "0.1px",
    // whiteSpace: "nowrap",
  },
  evThree: {
    position: "relative",
    left: "70%",
    top: "-60px",
  },
  evFour: {
    position: "relative",
    left: "30%",
    top: "-90px",
  },
  evFive: {
    position: "relative",
    left: "70%",
    top: "-40px",
  },
  evSix: {
    position: "relative",
    left: "25%",
    top: "-30px",
  },
  leftAlignOne: {
    position: "relative",
    left: "0%",
  },
  leftAlignTwo: {
    position: "relative",
  },
  // gcss
  featureContainer: {
    display: "flex",
    flexDirection: "column",
    // gap: "140px", // slightly larger vertical gap for desktop
    // padding: "100px 0",
    width: "100%",
  },

  featureRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    // gap: "80px",
    minHeight: "460px", // consistent height for large screens

    "@media (max-width: 1400px)": {
      // gap: "70px",
      minHeight: "460px",
    },
    "@media (max-width: 1200px)": {
      // gap: "50px",
      minHeight: "460px",
    },
    "@media (max-width: 992px)": {
      // gap: "30px",
      minHeight: "380px",
    },
    "@media (max-width: 768px)": {
      flexDirection: "column",
      textAlign: "center",
      // gap: "40px",
      minHeight: "auto",
    },
  },

  reverse: {
    flexDirection: "row-reverse",
    "@media (max-width: 768px)": {
      flexDirection: "column",
    },
  },

  featureImage: {
    flex: "1 1 100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& img": {
      width: "100%",
      height: "auto",
      marginBottom: "24px",
      objectFit: "contain",
      borderRadius: "8px",
      display: "block",
      aspectRatio: "22/16", // ensures image height scales consistently with width
    },
    "@media (max-width: 992px)": {
      flex: "1 1 100%",
    },
  },

  featureText: {
    flex: "1 1 40%",
    maxWidth: "520px",
    position: "relative",
    top: "-80px",
    "@media (max-width: 1400px)": {
      maxWidth: "480px",
    },
    "@media (max-width: 1200px)": {
      // maxWidth: "220px",
    },
    "@media (max-width: 992px)": {
      maxWidth: "360px",
    },
    "@media (max-width: 768px)": {
      maxWidth: "90%",
    },
    "& h3": {
      color: "#ff5c00",
      fontSize: "32px",
      fontWeight: 700,
      marginBottom: "12px",
      lineHeight: "38px",
      "@media (max-width: 1200px)": {
        fontSize: "24px",
        lineHeight: "30px",
      },
    },
    "& p": {
      color: "#212121",
      fontSize: "24px",
      lineHeight: "32px",
      fontWeight: 500,
      "@media (max-width: 1200px)": {
        fontSize: "22px",
        lineHeight: "28px",
      },
    },
  },

  textLeftOffset: {
    position: "relative",
    left: "-10%",
  },

  textRightOffset: {
    position: "relative",
    right: "-10%",
  },

  // gcss end
  formContainer: {
    width: "calc(100% - 148px)",
    maxWidth: "1440px",
    marginLeft: "auto",
    marginRight: "auto",
    boxSizing: "border-box",

    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    borderRadius: "32px",
    padding: "48px 24px",
    scrollMarginTop: "120px",
  },
  formGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)", // 2 columns
    gap: "24px 32px", // vertical & horizontal spacing between inputs
    width: "100%",
    "@media (max-width: 768px)": {
      gridTemplateColumns: "1fr", // stack inputs on mobile
    },
  },

  customDrawerContent: {
    width: "100%",
    margin: "0 auto",
  },

  "@media (max-width: 550px)": {
    margin0: {
      margin: "0px",
    },
    acrossCity: {
      fontSize: "14px",
    },
    hrLine: {
      margin: "0px 16px 16px 16px",
    },
    cardHeading: {
      fontSize: "16px",
      lineHeight: "24px",
    },
    cardPara: {
      fontSize: "14px",
      lineHeight: "22px",
    },
    ctaTwo: {
      padding: "8px 12px",
      fontSize: "14px",
    },
    drawerAutoHeight2: {
      height: "auto !important",
      borderTopLeftRadius: 20,
      borderTopRightRadius: 20,
    },
    drawerBodyHeight2: {
      height: "auto !important",
      padding: "0px 0px 32px 0px",
    },
    carouselContainer: {
      maxWidth: "376px",
      marginLeft: "0px",
    },
    topHeading: {
      fontSize: "16px",
      lineHeight: "22px",
      // marginBottom:"16px"
    },
    fs15: {
      fontSize: "15px",
    },
    evText: {
      fontSize: "16px !important",
      lineHeight: "20px",
    },
    handle: {
      fontSize: "14px",
      lineHeight: "20px",
    },
    eventTwo: {
      bottom: "5px",
    },
    evOne: {
      left: "60%",
    },
    evTwo: {
      right: "60%",
      top: "-25px",
    },
    evThree: {
      top: "-42px",
      left: "58%",
    },
    evFour: {
      top: "-58px",
      left: "20%",
    },
    evFive: {
      top: "-20px",
      left: "58%",
    },
    evSix: {
      top: "0px",
      left: "20%",
    },
    downShadow: {
      boxShadow: "4px 4px 23.1px 0px #84848440",
      padding: "16px",
    },
    eventImg: {
      width: "70%",
      height: "auto",
    },
    eventThree: {
      right: "25%",
    },
    eventFour: {
      right: "5%",
    },
    eventFive: {
      right: "35%",
    },
    eventSix: {
      right: "0%",
    },
    cardTopText: {
      fontSize: "18px",
    },
    cardParaText: {
      fontSize: "14px",
    },
    cardBody: {
      fontSize: "14px",
    },
    talkText: {
      fontSize: "16px",
    },
    participantInput: {
      display: "flex",
      width: "90%",
      fontWeight: 600,
      fontSize: 15,
      height: "36px",
      padding: "16px",
      alignItems: "center",
      flexShrink: 0,
      borderRadius: "15px",
      outline: "none",
      // borderBottom: "1px solid rgba(255, 78, 0, 0.6)",
      borderBottom: "1px solid #424242",
      border: "none",
      margin: "8px auto",
      color: "#333",
      borderRadius: "inherit",
      "&::placeholder": {
        color: "#ff4e00",
        fontWeight: 700,
        fontSize: 14,
      },
    },
    finalBox2: {
      width: "100%",
      justifyContent: "center",
      padding: "15px 16px",
    },
    finalBtn2: {
      width: "100%",
      borderRadius: "12px",
      background: "#FF4E00",
    },
    finalButton2: {
      display: "block",
      width: "100%",
      height: "48px",
      padding: "16px 76px",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      borderRadius: "12px",
      fontWeight: "700",
      color: "white",
      fontSize: "12px",
      lineHeight: "16px",
    },
    faqHead: {
      fontSize: "16px",
      lineHeight: "24px",
    },
    faqPara: {
      fontSize: "16px",
      lineHeight: "24px",
    },
    kmImage: {
      height: "28px",
    },
    shadowCard: {
      marginBottom: "16px",
    },
    faqDetail: {
      margin: "16px",
    },
    faqLine: {
      margin: "8px 0px",
    },
    circle: {
      bottom: "22px",
    },
    seeAll: {
      bottom: "-8px",
      "& svg": {
        width: "14px",
        height: "14px",
      },
    },
    mtM40: {
      marginTop: "40px",
    },
    mbM40: {
      marginBottom: "40px",
    },
  },

  "@media (max-width: 400px)": {},
  "@media (max-width: 380px)": {
    acrossCity: {
      fontSize: 13,
    },
    ctaTwo: {
      fontSize: 14,
      padding: "4px 8px",
    },
  },
  "@media (max-width: 360px)": {
    carouselContainer: {
      maxWidth: "330px",
    },
  },

  /* =========================================
   HOST GAME PAGE
   Desktop / Base Styles
========================================== */

  hostGamePage: {
    width: "100%",
    backgroundColor: "#ffffff",
    overflowX: "hidden",
    paddingTop: "102px",
  },

  slotsBanner: {
    width: "100%",
    height: "44px",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    backgroundColor: "#f5ad12",
    color: "#171840",

    fontSize: "16px",
    fontWeight: 700,
    padding: "24px 0px",
  },

  /* =========================================
   HERO
========================================== */

  heroSection: {
    width: "100%",
    backgroundColor: "#171840",
    color: "#ffffff",
    position: "relative",
    overflow: "hidden",
  },

  heroContainer: {
    width: "100%",
    maxWidth: "1280px",
    margin: "0 auto",

    display: "grid",
    gridTemplateColumns: "1.05fr 0.95fr",
    alignItems: "center",
    gap: "70px",

    padding: "76px 48px 90px",
  },

  heroContent: {
    width: "100%",
    maxWidth: "560px",
  },

  heroEyebrow: {
    fontSize: "13px",
    fontWeight: 700,
    letterSpacing: "2.5px",
    color: "#f1a716",
    textTransform: "uppercase",
    marginBottom: "16px",
  },

  heroTitle: {
    margin: 0,
    padding: 0,

    fontSize: "52px",
    lineHeight: 1.1,
    fontWeight: 800,
    letterSpacing: "0.3px",
    color: "#ffffff",
  },

  mobileFeatureArrow: {
    display: "none",
  },

  heroTitleAccent: {
    display: "block",

    color: "#f0501e",

    fontSize: "68px",
    lineHeight: 1.05,
    fontWeight: 800,

    margin: "8px 0",
  },

  heroDescription: {
    maxWidth: "500px",

    margin: "22px 0 34px",

    fontSize: "17px",
    lineHeight: 1.6,
    color: "#d4d4e4",
    fontWeight: 500,
  },

  /* =========================================
   HERO CTA
========================================== */

  hostGameButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",

    border: "none",
    borderRadius: "30px",

    backgroundColor: "#f0501e",
    color: "#ffffff",

    fontSize: "13px",
    fontWeight: 700,

    padding: "14px 26px",

    textTransform: "uppercase",
    letterSpacing: "0.4px",

    cursor: "pointer",
    whiteSpace: "nowrap",

    transition: "all 0.2s ease",

    "&:hover": {
      backgroundColor: "#d6431a",
      transform: "translateY(-1px)",
    },

    "&:focus": {
      outline: "none",
    },

    "&:focus-visible": {
      outline: "3px solid rgba(241, 167, 22, 0.5)",
      outlineOffset: "3px",
    },
  },

  hostGameButtonLarge: {
    fontSize: "15.5px",
    padding: "19px 38px",

    boxShadow: "0 14px 28px rgba(240, 80, 30, 0.35)",
  },

  /* =========================================
   HERO GAME CARD
========================================== */

  heroGameCard: {
    width: "100%",
    maxWidth: "450px",

    marginLeft: "auto",

    backgroundColor: "#ffffff",
    color: "#1c1c1c",

    borderRadius: "18px",

    padding: "24px 24px 20px",

    boxShadow: "0 30px 60px rgba(0, 0, 0, 0.35)",
  },

  gameCardHeader: {
    display: "flex",
    alignItems: "flex-start",

    gap: "12px",

    marginBottom: "16px",
  },

  gameCardIcon: {
    width: "40px",
    height: "40px",
    flexShrink: 0,

    borderRadius: "10px",
    backgroundColor: "#1c1c1c",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    overflow: "hidden",

    "& img": {
      width: "50%",
      height: "50%",
      objectFit: "contain",
      display: "block",
    },
  },

  gameCardHeading: {
    minWidth: 0,
    flex: 1,
  },

  gameCardTitle: {
    margin: 0,

    fontSize: "16px",
    lineHeight: 1.3,
    fontWeight: 800,

    color: "#1c1c1c",
  },

  gameCardLocation: {
    margin: "3px 0 0",

    fontSize: "13px",
    lineHeight: 1.4,

    color: "#6b6f7b",
    fontWeight: 500,
  },

  gameCardTime: {
    display: "flex",
    alignItems: "flex-start",

    gap: "6px",

    marginBottom: "14px",

    fontSize: "14px",
    fontWeight: 500,
    lineHeight: 1.4,

    color: "#1c1c1c",
  },

  gameCardSkill: {
    display: "inline-block",

    background: "linear-gradient(90deg, #f5c542, #f0501e)",

    color: "#ffffff",

    fontSize: "13px",
    fontWeight: 700,

    padding: "6px 14px",

    borderRadius: "14px",

    // marginBottom: "14px",
  },

  gameCardDivider: {
    width: "100%",

    borderTop: "1px solid #e7e7ee",

    margin: "12px 0 14px",
  },

  gameCardHostRow: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    flexWrap: "wrap",

    gap: "8px",

    marginBottom: "8px",
  },

  gameCardAvatar: {
    width: "48px",
    height: "48px",
    flexShrink: 0,

    borderRadius: "50%",
    backgroundColor: "#dddddd",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    overflow: "hidden",

    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "contain",
      display: "block",
    },
  },

  gameCardHostName: {
    display: "flex",
    alignItems: "center",

    gap: "4px",

    fontSize: "14px",
    fontWeight: 700,

    color: "#1c1c1c",
  },

  gameCardVerified: {
    width: "24px",
    height: "24px",

    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",

    backgroundColor: "#0b8f3c",
    color: "#ffffff",

    fontSize: "14px",
    fontWeight: 800,

    // Gives the cropped / badge-like shape
    clipPath:
      "polygon(50% 0%, 61% 7%, 74% 5%, 82% 16%, 95% 22%, 93% 36%, 100% 50%, 93% 63%, 95% 78%, 82% 84%, 74% 95%, 61% 93%, 50% 100%, 39% 93%, 26% 95%, 18% 84%, 5% 78%, 7% 63%, 0% 50%, 7% 36%, 5% 22%, 18% 16%, 26% 5%, 39% 7%)",

    flexShrink: 0,
  },

  gameCardTopHost: {
    display: "flex",
    alignItems: "center",

    gap: "3px",

    padding: "4px 9px",

    borderRadius: "10px",

    backgroundColor: "#1c1c1c",
    color: "#ffffff",

    fontSize: "10.5px",
    fontWeight: 700,

    whiteSpace: "nowrap",
  },

  gameCardCapacity: {
    width: "30px",
    height: "30px",
    flexShrink: 0,

    border: "3px solid #f0501e",
    borderRadius: "50%",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    color: "#f0501e",

    fontSize: "9.5px",
    fontWeight: 800,
  },
  gameCardSkillRow: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    marginTop: "18px",
  },

  gameCardInstantJoin: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    fontWeight: 600,
    whiteSpace: "nowrap",
    marginLeft: "16px",
  },

  gameCardSlots: {
    display: "flex",
    alignItems: "center",

    fontSize: "11.5px",
    fontWeight: 700,

    color: "#f0501e",
    whiteSpace: "nowrap",
  },

  gameCardPrice: {
    marginBottom: "8px",

    fontSize: "18px",
    fontWeight: 800,

    color: "#1c1c1c",
  },

  gameCardJoining: {
    margin: 0,

    fontSize: "12.5px",
    lineHeight: 1.4,

    color: "#1c8a3c",
    fontWeight: 400,
  },

  /* =========================================
   POPULAR SPORTS
========================================== */

  sportsSection: {
    width: "100%",

    backgroundColor: "#ffffff",

    borderBottom: "1px solid #e7e7ee",
  },

  sportsContainer: {
    maxWidth: "1180px",

    margin: "0 auto",

    padding: "26px 48px",

    textAlign: "center",
  },

  sportsSectionTitle: {
    margin: "0 0 14px",

    fontSize: "16px",
    fontWeight: 700,

    color: "#171840",

    textTransform: "uppercase",
    letterSpacing: "0.6px",
  },

  sportsList: {
    display: "flex",
    alignItems: "center",

    gap: "9px",

    padding: "2px 0 8px",
    margin: 0,

    listStyle: "none",

    overflowX: "auto",
    overflowY: "hidden",

    flexWrap: "nowrap",

    scrollBehavior: "smooth",

    scrollbarWidth: "none",

    "&::-webkit-scrollbar": {
      display: "none",
    },
  },

  sportsChip: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",

    flexShrink: 0,

    padding: "8px 16px",

    border: "1px solid #e7e7ee",
    borderRadius: "18px",

    backgroundColor: "#f5f5f8",

    color: "#1c1c1c",

    fontSize: "13px",
    fontWeight: 600,

    whiteSpace: "nowrap",
  },

  /* =========================================
   HOW IT WORKS
   Desktop / Base Styles
========================================== */

  howItWorksSection: {
    width: "100%",
    backgroundColor: "#ffffff",
    overflow: "hidden",
  },

  howItWorksContainer: {
    width: "100%",
    maxWidth: "1120px",
    margin: "0 auto",

    padding: "70px 40px 80px",
  },

  howItWorksPara: {
    textAlign: "center",

    fontSize: "22px",
    lineHeight: 1.2,
    fontWeight: 600,
    margin: "0 0 64px",

    color: "#424242",
  },

  howItWorksTitle: {
    margin: "0 0 16px",

    textAlign: "center",

    fontSize: "40px",
    lineHeight: 1.2,
    fontWeight: 800,

    color: "#424242",

    "& span": {
      color: "#f0501e",
    },
  },

  howItWorksSteps: {
    width: "100%",
  },

  /* =========================================
   INDIVIDUAL STEP
========================================== */

  howItWorksStep: {
    width: "100%",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    minHeight: "350px",

    gap: "70px",
  },

  stepReverse: {
    flexDirection: "row-reverse",
  },

  /* =========================================
   STEP VISUAL
========================================== */

  stepVisual: {
    width: "50%",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    flexShrink: 0,
  },

  stepImage: {
    display: "block",

    width: "100%",
    maxWidth: "350px",
    height: "auto",

    objectFit: "contain",
  },

  /* =========================================
   STEP CONTENT
========================================== */

  stepContent: {
    width: "40%",
    maxWidth: "400px",

    display: "flex",
    flexDirection: "column",
    justifyContent: "center",

    textAlign: "left",
  },

  stepLabel: {
    margin: "0 0 8px",

    fontSize: "18px",
    lineHeight: 1.3,
    fontWeight: 700,

    color: "#424242",
  },

  stepTitle: {
    margin: "0 0 10px",

    fontSize: "22px",
    lineHeight: 1.25,
    fontWeight: 800,

    color: "#f0501e",
  },

  stepDescription: {
    margin: 0,

    fontSize: "17px",
    lineHeight: 1.5,
    fontWeight: 500,

    color: "#424242",
  },

  /* =========================================
   STEP ARROW
========================================== */
  stepArrow: {
    width: "100%",
    height: "164px",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    pointerEvents: "none",

    "& img": {
      display: "block",
      maxWidth: "100%",
      height: "auto",
    },
  },

  /* =========================================
   STEP 1 CONTENT + ARROW
   Desktop / Base
========================================== */

  stepContentWithArrow: {
    width: "40%",
    maxWidth: "400px",

    display: "flex",
    flexDirection: "column",

    alignItems: "flex-start",
    justifyContent: "center",

    textAlign: "left",
  },

  stepOneArrow: {
    display: "block",

    width: "auto",
    height: "auto",

    margin: "32px 0px 0px 32px",

    alignSelf: "flex-start",
  },
  /* =========================================
   CTA
========================================== */

  howItWorksCta: {
    display: "flex",
    justifyContent: "center",

    marginTop: "40px",
  },

  // download app banner css

  downloadAppSection: {
    width: "100%",
    padding: "20px 40px 70px",
    display: "flex",
    justifyContent: "center",
    backgroundColor: "#fff",
  },

  downloadAppLink: {
    display: "block",
    width: "100%",
    maxWidth: "1120px",
    cursor: "pointer",
  },

  downloadAppImage: {
    display: "block",
    width: "100%",
    height: "auto",
    objectFit: "contain",
  },

  /* =========================================
   HOSTING GUIDE
   Desktop / Base Styles
========================================== */

  hostingGuideSection: {
    width: "100%",

    backgroundColor: "#f5f5f8",

    overflow: "hidden",
  },

  hostingGuideContainer: {
    width: "100%",
    maxWidth: "1180px",

    margin: "0 auto",

    padding: "70px 40px 80px",
  },

  /* =========================================
   SECTION HEADER
========================================== */

  hostingGuideHeader: {
    maxWidth: "720px",

    margin: "0 auto 42px",

    textAlign: "center",
  },

  hostingGuideEyebrow: {
    margin: "0 0 10px",

    fontSize: "12px",
    lineHeight: 1.3,
    fontWeight: 700,

    color: "#f0501e",

    textTransform: "uppercase",
    letterSpacing: "1.5px",
  },

  hostingGuideTitle: {
    margin: "0 0 12px",

    fontSize: "36px",
    lineHeight: 1.2,
    fontWeight: 800,

    color: "#333333",
  },

  hostingGuideDescription: {
    maxWidth: "600px",

    margin: "0 auto",

    fontSize: "16px",
    lineHeight: 1.5,
    fontWeight: 400,

    color: "#171840",
    fontWeight: 500,
  },

  /* =========================================
   CARDS
========================================== */

  hostingGuideList: {
    width: "100%",

    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",

    // display: "grid",
    // gridTemplateColumns: "repeat(2, minmax(0, 1fr))",

    // gap: "28px",
  },

  hostingGuideCard: {
    width: "100%",
    maxWidth: "440px",

    backgroundColor: "#ffffff",

    borderRadius: "18px",

    overflow: "hidden",

    boxShadow: "0 6px 24px rgba(0, 0, 0, 0.08)",

    border: "1px solid #e8e8e8",

    transition: "transform 0.2s ease, box-shadow 0.2s ease",

    "&:hover": {
      transform: "translateY(-3px)",

      boxShadow: "0 10px 30px rgba(0, 0, 0, 0.12)",
    },
  },

  /* =========================================
   VIDEO AREA
========================================== */

  hostingGuideVideo: {
    width: "100%",
    maxWidth: "400px",
    aspectRatio: "9 / 16",
    margin: "0 auto",
    overflow: "hidden",
    borderRadius: "16px",
    backgroundColor: "#000",
    margin: "16px",
  },

  hostingGuideIframe: {
    width: "100%",
    height: "100%",
    border: 0,
    display: "block",
  },

  videoPlaceholder: {
    width: "100%",
    height: "100%",

    display: "flex",
    flexDirection: "column",

    alignItems: "center",
    justifyContent: "center",

    gap: "10px",

    color: "#777777",
  },

  videoPlaceholderIcon: {
    width: "52px",
    height: "52px",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    borderRadius: "50%",

    backgroundColor: "#f0501e",
    color: "#ffffff",

    fontSize: "19px",

    paddingLeft: "3px",
  },

  videoPlaceholderText: {
    fontSize: "13px",
    fontWeight: 600,

    color: "#777777",
  },

  /* =========================================
   CARD CONTENT
========================================== */

  hostingGuideCardContent: {
    padding: "22px 24px 24px",
  },

  hostingGuideCardTitle: {
    margin: "0 0 8px",

    fontSize: "19px",
    lineHeight: 1.35,
    fontWeight: 800,

    color: "#333333",
  },

  hostingGuideCardDescription: {
    margin: 0,

    fontSize: "14px",
    lineHeight: 1.55,
    color: "#171840",
    fontWeight: 500,
  },

  /* =========================================
   BENEFITS FOR HOSTS
   Desktop / Base Styles
========================================== */

  hostBenefitsSection: {
    width: "100%",

    backgroundColor: "#ffffff",

    overflow: "hidden",
  },

  hostBenefitsContainer: {
    width: "100%",

    maxWidth: "1000px",

    margin: "0 auto",

    padding: "65px 40px 75px",
  },

  hostBenefitsTitle: {
    margin: "0 0 40px",

    textAlign: "center",

    fontSize: "28px",
    lineHeight: 1.2,
    fontWeight: 800,

    color: "#333333",
  },

  hostBenefitsGrid: {
    display: "grid",

    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",

    columnGap: "50px",
    rowGap: "28px",
  },

  hostBenefitItem: {
    display: "flex",

    alignItems: "flex-start",

    gap: "14px",

    minWidth: 0,
  },

  hostBenefitCheck: {
    width: "22px",
    height: "22px",

    flexShrink: 0,

    marginTop: "2px",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    borderRadius: "5px",

    backgroundColor: "#f0501e",

    color: "#ffffff",

    fontSize: "13px",
    fontWeight: 800,

    lineHeight: 1,
  },

  hostBenefitItem: {
    display: "flex",

    alignItems: "flex-start",

    gap: "14px",

    minWidth: 0,

    "& p": {
      margin: 0,

      fontSize: "15px",
      lineHeight: 1.55,

      color: "#424242",
      fontWeight: 500,
    },

    "& strong": {
      fontWeight: 700,
    },
  },

  /* =========================================
   EVERYTHING YOU GET
   Desktop / Base Styles
========================================== */

  featureHighlightsSection: {
    width: "100%",

    backgroundColor: "#f5f5f8",

    overflow: "hidden",
  },

  featureHighlightsContainer: {
    width: "100%",

    maxWidth: "1180px",

    margin: "0 auto",

    padding: "70px 40px 80px",
  },

  /* =========================================
   SECTION HEADER
========================================== */

  featureHighlightsHeader: {
    textAlign: "center",

    marginBottom: "42px",
  },

  featureHighlightsTitle: {
    margin: "0 0 8px",

    fontSize: "28px",
    lineHeight: 1.25,
    fontWeight: 800,

    color: "#333333",
  },

  featureHighlightsSubtitle: {
    margin: 0,

    fontSize: "18px",
    lineHeight: 1.5,

    color: "#171840",
    fontWeight: 500,
  },

  /* =========================================
   FEATURE GROUP
========================================== */

  featureGroup: {
    width: "100%",

    marginBottom: "42px",

    "&:last-child": {
      marginBottom: 0,
    },
  },

  featureGroupTitle: {
    margin: "0 0 32px",

    fontSize: "24px",
    lineHeight: 1.3,
    fontWeight: 700,

    color: "#333333",

    "& span": {
      color: "#f0501e",
    },
  },

  /* =========================================
   FEATURE GROUP HEADER
========================================= */

  featureGroupHeader: {
    width: "100%",

    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",

    gap: "20px",
  },

  /* =========================================
   MOBILE ACCORDION TOGGLE
   Hidden on desktop/tablet
========================================= */

  featureAccordionToggle: {
    display: "none",

    border: "none",
    background: "transparent",

    padding: 0,

    color: "#f0501e",

    fontSize: "13px",
    fontWeight: 800,

    cursor: "pointer",

    whiteSpace: "nowrap",
  },

  /* =========================================
   MOBILE ACCORDION
   Desktop/tablet do not use this layout
========================================= */

  featureAccordion: {
    width: "100%",
  },

  featureAccordionContent: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "28px",

    overflowX: "auto",
    overflowY: "hidden",

    scrollBehavior: "smooth",
    scrollbarWidth: "none",

    "&::-webkit-scrollbar": {
      display: "none",
    },

    paddingBottom: "10px",
    boxSizing: "border-box",
  },

  featureCardReverse: {
    flexDirection: "row",
  },
  /* =========================================
   HORIZONTAL SCROLL
========================================== */

  featureScroll: {
    width: "100%",

    display: "flex",
    alignItems: "center",

    gap: "28px",

    overflowX: "auto",
    overflowY: "hidden",

    padding: "4px 2px 14px",

    scrollBehavior: "smooth",

    scrollbarWidth: "none",

    "&::-webkit-scrollbar": {
      display: "none",
    },
  },

  /* =========================================
   FEATURE CARD
   Desktop / Base
========================================== */

  featureCard: {
    flex: "0 0 360px",

    minWidth: 0,

    display: "flex",
    alignItems: "center",

    gap: "24px",

    scrollSnapAlign: "start",
  },

  featureImageWrapper: {
    width: "164px",
    height: "auto",

    flexShrink: 0,

    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  featureImage: {
    display: "block",

    width: "100%",
    height: "100%",

    objectFit: "contain",
  },

  featureContent: {
    minWidth: 0,

    flex: 1,
  },

  featureCardTitle: {
    margin: "0 0 10px",

    fontSize: "22px",
    lineHeight: 1.25,
    fontWeight: 800,

    color: "#f0501e",
  },

  featureCardDescription: {
    margin: 0,

    fontSize: "17px",
    lineHeight: 1.5,
    fontWeight: 500,

    color: "#444444",
  },

  hostFeatureGroup: {
    padding: "24px 26px 26px",

    backgroundColor: "#fff",

    border: "1px solid #f8ddd1",

    borderRadius: "18px",
  },

  playerFeatureGroup: {
    padding: "24px 26px 26px",

    backgroundColor: "#f7f8fa",

    border: "1px solid #e2e5ea",

    borderRadius: "18px",
  },
  /* =========================================
   HOST YOUR GAME CTA
   Desktop / Base Styles
========================================== */

  hostGameCtaSection: {
    width: "100%",

    minHeight: "325px",

    backgroundColor: "#fff8f2",

    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    borderTop: "1px solid #e5e5e5",
    borderBottom: "1px solid #e5e5e5",
  },

  hostGameNewTitle: {
    margin: "0 0 16px",

    textAlign: "center",

    fontSize: "28px",
    lineHeight: 1.2,
    fontWeight: 700,

    color: "#424242",

    "& span": {
      color: "#f0501e",
    },
  },

  hostGameNewPara: {
    textAlign: "center",

    fontSize: "20px",
    padding: "0 32px",
    lineHeight: 1.4,
    fontWeight: 600,
    margin: "0 0 32px",

    color: "#424242",
  },

  hostGameCtaButton: {
    display: "inline-flex",

    alignItems: "center",
    justifyContent: "center",

    width: "320px",
    height: "64px",
    padding: "32px",

    borderRadius: "60px",

    backgroundColor: "#f4511e",
    color: "#ffffff",

    fontSize: "18px",
    fontWeight: 700,

    textDecoration: "none",

    boxShadow: "0 18px 35px rgba(244, 81, 30, 0.28)",

    transition: "transform 0.2s ease, box-shadow 0.2s ease",

    "&:hover": {
      color: "#ffffff",

      transform: "translateY(-2px)",

      boxShadow: "0 20px 40px rgba(244, 81, 30, 0.35)",
    },
  },

  /* =========================================
   FORM OR DIVIDER
   Desktop / Base
========================================== */

  formOrDivider: {
    width: "100%",
    maxWidth: "760px",

    margin: "32px auto",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    gap: "28px",
  },

  formOrLine: {
    flex: 1,

    height: "1px",

    backgroundColor: "#e1e3e8",
    display: "block",
  },

  formOrText: {
    display: "block",

    flexShrink: 0,

    fontSize: "24px",
    lineHeight: 1,

    fontWeight: 800,

    color: "#6f737d",
  },

  /* =========================================
   LOGIN + APP DOWNLOAD
   Desktop / Base
========================================== */

  appLinksSection: {
    width: "100%",
    backgroundColor: "#ffffff",
  },

  appLinksContainer: {
    width: "100%",
    maxWidth: "760px",

    margin: "24px auto 0px auto",

    padding: "42px 24px 48px",

    display: "flex",
    flexDirection: "column",
    alignItems: "center",

    boxSizing: "border-box",
  },

  /* =========================================
   LOGIN
========================================== */

  loginText: {
    margin: 0,

    fontSize: "18px",
    lineHeight: 1.4,
    fontWeight: 500,

    color: "#1c1c1c",

    textAlign: "center",

    "& a": {
      color: "#f0501e",
      fontWeight: 700,
      textDecoration: "none",
    },
  },

  /* =========================================
   APP STORE / GOOGLE PLAY
========================================== */

  storeLinks: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    gap: "14px",

    marginTop: "24px",
  },

  storeLink: {
    display: "block",

    lineHeight: 0,

    textDecoration: "none",
  },

  storeBadge: {
    display: "block",

    width: "150px",
    height: "auto",

    objectFit: "contain",
  },

  /* =========================================
   SOCIAL LINKS
========================================== */

  socialLinks: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    gap: "16px",

    marginTop: "28px",
  },

  socialIcon: {
    width: "48px",
    height: "48px",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    borderRadius: "50%",

    backgroundColor: "#fff",

    color: "#171717",

    textDecoration: "none",

    overflow: "hidden",

    transition: "transform 0.2s ease",

    "&:hover": {
      transform: "translateY(-2px)",
    },

    "& img": {
      display: "block",

      width: "100%",
      height: "100%",

      objectFit: "contain",
    },
  },

  xIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    width: "100%",
    height: "100%",

    color: "#fff",
    backgroundColor: "#171717",

    fontSize: "19px",
    fontWeight: 500,

    lineHeight: 1,
  },

  /* =========================================
   CONTACT
========================================== */

  contactDivider: {
    width: "100%",

    borderTop: "1px solid #e7e7ee",

    marginTop: "34px",
  },

  contactText: {
    margin: "28px 0 0",

    fontSize: "16px",
    lineHeight: 1.5,

    color: "#171840",

    fontWeight: 500,

    textAlign: "center",

    "& a": {
      color: "#f0501e",
      fontWeight: 700,
      textDecoration: "none",
    },
  },

  /* =========================================
   FAQ SECTION
   Desktop / Base Styles
========================================== */

  faqSection: {
    width: "100%",

    backgroundColor: "#ffffff",

    padding: "42px 24px 60px",

    boxSizing: "border-box",
    scrollMarginTop: "90px",
  },

  faqContainer: {
    width: "100%",
    maxWidth: "900px",

    margin: "0 auto",

    padding: "42px 48px 44px",

    backgroundColor: "#ffffff",

    border: "1px solid #e2e3e8",

    borderRadius: "28px",

    boxShadow: "0 8px 28px rgba(23, 24, 64, 0.04)",

    boxSizing: "border-box",
    scrollMarginTop: "90px",
  },

  /* =========================================
   FAQ HEADER
========================================== */

  faqHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",

    gap: "20px",

    marginBottom: "26px",
  },

  faqTitle: {
    margin: 0,
    padding: 0,

    fontSize: "28px",
    lineHeight: 1.2,

    fontWeight: 800,

    color: "#1c1c1c",
  },

  faqToggleTop: {
    margin: 0,
    padding: 0,

    border: "none",

    backgroundColor: "transparent",

    color: "#f0501e",

    fontSize: "15px",
    fontWeight: 800,

    cursor: "pointer",

    whiteSpace: "nowrap",

    "&:focus": {
      outline: "none",
    },

    "&:focus-visible": {
      outline: "2px solid rgba(240, 80, 30, 0.4)",
      outlineOffset: "4px",

      borderRadius: "3px",
    },
  },

  /* =========================================
   FAQ LIST
========================================== */

  faqList: {
    width: "100%",
  },

  faqItem: {
    width: "100%",

    margin: "0 0 26px",

    "&:last-child": {
      marginBottom: 0,
    },
  },

  faqItemHidden: {
    display: "none",
  },

  /* =========================================
   FAQ QUESTION
========================================== */

  faqQuestion: {
    margin: 0,
    padding: 0,

    fontSize: "18px",
    lineHeight: 1.4,

    fontWeight: 800,

    color: "#1c1c1c",
  },

  /* =========================================
   FAQ ANSWER
========================================== */

  faqAnswer: {
    margin: "8px 0 0",
    padding: 0,

    fontSize: "16px",
    lineHeight: 1.55,

    fontWeight: 500,

    color: "#6b6f7b",
  },

  /* =========================================
   BOTTOM SEE LESS
========================================== */

  faqBottomAction: {
    display: "flex",

    justifyContent: "flex-end",

    marginTop: "30px",
  },

  faqToggleBottom: {
    margin: 0,
    padding: 0,

    border: "none",

    backgroundColor: "transparent",

    color: "#f0501e",

    fontSize: "15px",
    fontWeight: 800,

    cursor: "pointer",

    whiteSpace: "nowrap",

    "&:focus": {
      outline: "none",
    },

    "&:focus-visible": {
      outline: "2px solid rgba(240, 80, 30, 0.4)",
      outlineOffset: "4px",

      borderRadius: "3px",
    },
  },

  /* =========================================
   FINAL HOST CTA
========================================== */

  finalHostCtaInner: {
    position: "relative",

    zIndex: 2,

    width: "100%",

    maxWidth: "1280px",

    minHeight: "300px",

    margin: "0 auto",

    padding: "72px 60px 70px",

    display: "flex",

    alignItems: "center",

    justifyContent: "space-between",

    boxSizing: "border-box",
  },

  finalHostCtaContent: {
    position: "relative",

    zIndex: 2,
  },

  finalHostCtaTagline: {
    margin: 0,

    fontFamily: "Georgia, 'Times New Roman', serif",

    fontSize: "36px",

    lineHeight: 1.2,

    fontStyle: "italic",

    fontWeight: 600,

    color: "#ffffff",
  },

  finalHostCtaText: {
    margin: "42px 0 0",

    display: "block",

    fontSize: "26px",

    lineHeight: 1.3,

    fontWeight: 600,

    color: "#ffffff",

    "& span": {
      color: "#f6aa12",
    },
  },

  finalHostCtaButton: {
    position: "relative",

    zIndex: 3,

    border: "none",

    borderRadius: "30px",

    backgroundColor: "#f6aa12",

    color: "#191943",

    padding: "17px 36px",

    minWidth: "230px",

    fontSize: "16px",

    lineHeight: 1,

    fontWeight: 800,

    cursor: "pointer",

    whiteSpace: "nowrap",

    boxSizing: "border-box",

    transition: "transform 0.2s ease",

    "&:hover": {
      transform: "translateY(-2px)",
    },

    "&:focus": {
      outline: "none",
    },

    "&:focus-visible": {
      outline: "2px solid #ffffff",

      outlineOffset: "4px",
    },
  },

  /* =========================================
   ORANGE CURVE
========================================== */

  finalHostCta: {
    position: "relative",

    marginBottom: "42px",

    width: "100%",

    minHeight: "300px",

    backgroundColor: "#191943",

    overflow: "hidden",

    boxSizing: "border-box",

    "&:after": {
      content: '""',

      position: "absolute",

      zIndex: 1,

      left: "-8%",

      bottom: "-210px",

      width: "64%",

      height: "280px",

      backgroundColor: "#f4511e",

      borderRadius: "50% 50% 0 0 / 100% 100% 0 0",

      transform: "rotate(-1deg)",
    },
  },

  /* =========================================================
   TABLET
   768px - 1024px
========================================================= */

  "@media (min-width: 768px) and (max-width: 1024px)": {
    heroContainer: {
      gridTemplateColumns: "1fr 0.9fr",
      gap: "40px",

      padding: "60px 32px 70px",
    },

    hostGamePage: {
      paddingTop: "102px",
    },

    heroTitle: {
      fontSize: "44px",
    },

    heroTitleAccent: {
      fontSize: "56px",
    },

    heroDescription: {
      fontSize: "16px",

      margin: "20px 0 30px",
    },

    heroGameCard: {
      maxWidth: "370px",
    },

    sportsContainer: {
      padding: "24px 32px",
    },

    howItWorksContainer: {
      maxWidth: "900px",

      padding: "60px 32px 70px",
    },

    howItWorksPara: {
      fontSize: "16px",
      marginBottom: "32px",
    },

    howItWorksTitle: {
      fontSize: "34px",
    },

    howItWorksStep: {
      minHeight: "300px",

      gap: "45px",
    },

    stepVisual: {
      width: "48%",
    },

    stepImage: {
      maxWidth: "330px",
    },

    stepContent: {
      width: "42%",
      maxWidth: "340px",
    },

    stepLabel: {
      fontSize: "16px",
    },

    stepTitle: {
      fontSize: "20px",
    },

    stepDescription: {
      fontSize: "15px",
      lineHeight: 1.45,
    },

    stepArrow: {
      height: "65px",

      "& img": {
        maxWidth: "180px",
      },
    },

    stepContentWithArrow: {
      width: "42%",
      maxWidth: "340px",
    },

    stepOneArrow: {
      width: "105px",
      marginTop: "6px",
    },

    howItWorksCta: {
      marginTop: "30px",
    },

    downloadAppSection: {
      padding: "15px 32px 60px",
    },

    downloadAppLink: {
      maxWidth: "900px",
    },

    /* =========================================
   HOSTING GUIDE
   Tablet
   768px - 1024px
========================================== */
    hostingGuideContainer: {
      padding: "55px 32px 65px",
    },

    hostingGuideHeader: {
      marginBottom: "32px",
    },

    hostingGuideTitle: {
      fontSize: "32px",
    },

    hostingGuideDescription: {
      fontSize: "15px",
    },

    hostingGuideList: {
      display: "flex",

      gap: "20px",

      overflowX: "auto",
      overflowY: "hidden",

      scrollSnapType: "x mandatory",

      paddingBottom: "8px",

      scrollbarWidth: "none",

      "&::-webkit-scrollbar": {
        display: "none",
      },
    },

    hostingGuideVideo: {
      maxWidth: "360px",
    },

    hostingGuideCard: {
      width: "100%",
      maxWidth: "400px",
    },

    hostingGuideCardContent: {
      padding: "20px 22px 22px",
    },

    hostingGuideCardTitle: {
      fontSize: "18px",
    },

    hostingGuideCardDescription: {
      fontSize: "14px",
    },
    hostBenefitsContainer: {
      maxWidth: "760px",

      padding: "55px 32px 65px",
    },

    hostBenefitsTitle: {
      fontSize: "26px",

      marginBottom: "32px",
    },

    hostBenefitsGrid: {
      gridTemplateColumns: "1fr",

      rowGap: "22px",

      maxWidth: "650px",

      margin: "0 auto",
    },

    hostBenefitItem: {
      gap: "12px",

      "& p": {
        fontSize: "15px",
        lineHeight: 1.5,
      },
    },
    featureHighlightsContainer: {
      padding: "55px 32px 65px",
    },

    featureHighlightsHeader: {
      marginBottom: "34px",
    },

    featureHighlightsTitle: {
      fontSize: "26px",
    },

    featureGroup: {
      marginBottom: "36px",
    },

    featureGroupTitle: {
      fontSize: "15px",

      marginBottom: "16px",
    },

    featureScroll: {
      gap: "24px",

      paddingBottom: "12px",

      scrollSnapType: "x mandatory",
    },

    featureCard: {
      flex: "0 0 235px",

      gap: "14px",
    },
    featureCardTitle: {
      fontSize: "12.5px",
    },

    featureCardDescription: {
      fontSize: "11px",
    },
    hostFeatureGroup: {
      padding: "20px 22px 22px",

      borderRadius: "16px",
    },

    playerFeatureGroup: {
      padding: "20px 22px 22px",

      borderRadius: "16px",
    },
    hostGameCtaSection: {
      minHeight: "270px",
    },
    hostGameNewTitle: {
      fontSize: "22px",
    },

    hostGameNewPara: {
      fontSize: "20px",
      padding: "0 42px",

      margin: "0 0 32px",
    },
    hostGameCtaButton: {
      height: "48px",

      borderRadius: "50px",

      fontSize: "16px",
    },
    formOrDivider: {
      maxWidth: "680px",

      gap: "22px",
    },

    formOrText: {
      fontSize: "21px",
    },

    finalBox2: {
      justifyContent: "center",
    },
    appLinksContainer: {
      maxWidth: "700px",

      padding: "40px 32px 44px",
    },

    loginText: {
      fontSize: "17px",
    },

    storeLinks: {
      gap: "12px",
      marginTop: "22px",
    },

    storeBadge: {
      width: "145px",
    },

    socialLinks: {
      gap: "14px",
      marginTop: "26px",
    },

    socialIcon: {
      width: "46px",
      height: "46px",
    },

    xIcon: {
      fontSize: "18px",
    },

    contactDivider: {
      marginTop: "32px",
    },

    contactText: {
      marginTop: "26px",
      fontSize: "15px",
    },
    /* =========================================
   FAQ
   Tablet
========================================== */

    faqSection: {
      padding: "38px 24px 52px",
    },

    faqContainer: {
      maxWidth: "760px",

      padding: "36px 36px 40px",

      borderRadius: "24px",
    },

    faqHeader: {
      marginBottom: "24px",
    },

    faqTitle: {
      fontSize: "25px",
    },

    faqToggleTop: {
      fontSize: "14px",
    },

    faqQuestion: {
      fontSize: "17px",
    },

    faqAnswer: {
      fontSize: "15px",

      lineHeight: 1.55,
    },

    faqItem: {
      marginBottom: "24px",
    },

    faqToggleBottom: {
      fontSize: "14px",
    },

    finalHostCtaInner: {
      minHeight: "270px",

      padding: "60px 40px 65px",
    },

    finalHostCtaTagline: {
      fontSize: "32px",
    },

    finalHostCtaText: {
      marginTop: "34px",

      fontSize: "23px",
    },

    finalHostCtaButton: {
      minWidth: "205px",

      padding: "15px 28px",

      fontSize: "15px",
    },

    finalHostCta: {
      minHeight: "270px",

      "&:after": {
        left: "-12%",

        bottom: "-185px",

        width: "70%",

        height: "245px",
      },
    },
  },

  /* =========================================================
   MOBILE
   Below 768px
========================================================= */

  "@media (max-width: 767px)": {
    heroContainer: {
      display: "flex",
      flexDirection: "column",

      alignItems: "stretch",

      gap: "40px",

      padding: "50px 24px 60px",
    },

    hostGamePage: {
      paddingTop: "112px",
    },

    heroContent: {
      maxWidth: "100%",
    },

    heroEyebrow: {
      fontSize: "12px",
      letterSpacing: "2px",

      marginBottom: "14px",
    },

    heroTitle: {
      fontSize: "43px",
    },

    heroTitleAccent: {
      fontSize: "55px",
    },

    heroDescription: {
      maxWidth: "100%",

      fontSize: "16px",
      lineHeight: 1.55,

      margin: "18px 0 28px",
    },

    heroGameCard: {
      maxWidth: "480px",

      margin: "0 auto",
    },

    gameCardSkill: {
      fontSize: "12px",
      fontWeight: 600,
      whiteSpace: "nowrap",
    },

    gameCardAvatar: {
      width: "30px",
      height: "30px",
    },
    sportsContainer: {
      padding: "24px",
    },

    sportsList: {
      justifyContent: "flex-start",

      marginLeft: "-24px",
      marginRight: "-24px",

      paddingLeft: "24px",
      paddingRight: "24px",
    },

    howItWorksContainer: {
      padding: "48px 20px 60px",
    },

    howItWorksPara: {
      fontSize: "16px",
      lineHeight: 1.4,
      marginBottom: "32px",
    },

    howItWorksTitle: {
      fontSize: "30px",
    },

    howItWorksStep: {
      minHeight: "230px",

      gap: "20px",
    },

    stepReverse: {
      flexDirection: "row-reverse",
    },

    stepVisual: {
      width: "50%",
    },

    stepImage: {
      width: "100%",
      maxWidth: "250px",
    },

    stepContent: {
      width: "43%",
      maxWidth: "240px",
    },

    stepLabel: {
      fontSize: "14px",
      lineHeight: 1.3,

      marginBottom: "6px",
    },

    stepTitle: {
      fontSize: "17px",
      lineHeight: 1.25,

      marginBottom: "7px",
    },

    stepDescription: {
      fontSize: "13px",
      lineHeight: 1.45,
    },

    stepArrow: {
      height: "48px",

      "& img": {
        maxWidth: "120px",
      },
    },

    stepContentWithArrow: {
      width: "43%",
      maxWidth: "240px",
    },

    stepOneArrow: {
      width: "80px",
      marginTop: "5px",
    },

    howItWorksCta: {
      marginTop: "25px",
    },

    downloadAppSection: {
      padding: "15px 20px 45px",
    },

    downloadAppLink: {
      width: "100%",
    },

    downloadAppImage: {
      width: "100%",
      height: "auto",
    },

    /* =========================================
   HOSTING GUIDE
   Mobile
   Below 768px
========================================== */

    hostingGuideContainer: {
      padding: "45px 20px 55px",
    },

    hostingGuideHeader: {
      marginBottom: "28px",
    },

    hostingGuideEyebrow: {
      fontSize: "11px",

      marginBottom: "8px",
    },

    hostingGuideTitle: {
      fontSize: "28px",

      lineHeight: 1.2,
    },

    hostingGuideDescription: {
      fontSize: "14px",

      lineHeight: 1.5,
    },

    hostingGuideList: {
      display: "flex",

      gap: "16px",

      overflowX: "auto",
      overflowY: "hidden",

      scrollSnapType: "x mandatory",

      paddingBottom: "8px",

      scrollbarWidth: "none",

      justifyContent: "center",

      "&::-webkit-scrollbar": {
        display: "none",
      },
    },

    hostingGuideCard: {
      width: "100%",
      maxWidth: "360px",

      borderRadius: "16px",
    },
    hostingGuideVideo: {
      width: "100%",
      maxWidth: "360px",
      aspectRatio: "9 / 16",
      margin: "0px",
    },
    hostingGuideCardContent: {
      padding: "18px 18px 20px",
    },

    hostingGuideCardTitle: {
      fontSize: "17px",

      marginBottom: "7px",
    },

    hostingGuideCardDescription: {
      fontSize: "13px",

      lineHeight: 1.5,
    },

    videoPlaceholderIcon: {
      width: "46px",
      height: "46px",

      fontSize: "17px",
    },

    videoPlaceholderText: {
      fontSize: "12px",
    },
    hostBenefitsContainer: {
      padding: "45px 20px 55px",
    },

    hostBenefitsTitle: {
      fontSize: "25px",

      marginBottom: "28px",
    },

    hostBenefitsGrid: {
      gridTemplateColumns: "1fr",

      rowGap: "18px",
    },

    hostBenefitItem: {
      gap: "11px",

      "& p": {
        fontSize: "14px",
        lineHeight: 1.5,
      },
    },

    hostBenefitCheck: {
      width: "21px",
      height: "21px",

      fontSize: "12px",
    },

    featureHighlightsContainer: {
      padding: "45px 20px 55px",
    },

    featureHighlightsHeader: {
      marginBottom: "30px",
    },

    featureHighlightsTitle: {
      fontSize: "25px",
    },

    featureHighlightsSubtitle: {
      fontSize: "13px",
    },

    featureGroup: {
      marginBottom: "32px",
    },

    featureGroupTitle: {
      fontSize: "15px",

      marginBottom: "14px",
    },

    featureScroll: {
      gap: "20px",

      marginLeft: "-20px",
      marginRight: "-20px",

      paddingLeft: "20px",
      paddingRight: "20px",

      paddingBottom: "10px",

      scrollSnapType: "x mandatory",
    },

    featureCard: {
      flex: "0 0 270px",

      gap: "14px",

      scrollSnapAlign: "start",
    },
    featureCardTitle: {
      fontSize: "12.5px",
    },

    featureCardDescription: {
      fontSize: "11px",

      lineHeight: 1.45,
    },
    hostFeatureGroup: {
      padding: "18px 18px 20px",

      borderRadius: "15px",
    },

    playerFeatureGroup: {
      padding: "18px 18px 20px",

      borderRadius: "15px",
    },
    hostGameCtaSection: {
      minHeight: "220px",

      padding: "30px 20px",
    },

    hostGameNewTitle: {
      fontSize: "18px",
    },

    hostGameNewPara: {
      fontSize: "16px",
      padding: "0 32px",
      fontWeight: 500,
    },

    hostGameCtaButton: {
      width: "100%",
      maxWidth: "380px",

      height: "48px",

      borderRadius: "40px",

      fontSize: "16px",
    },
    appLinksContainer: {
      width: "100%",

      padding: "36px 20px 40px",

      boxSizing: "border-box",
    },

    loginText: {
      fontSize: "16px",
    },

    storeLinks: {
      gap: "10px",

      marginTop: "20px",
    },

    storeBadge: {
      width: "140px",
    },

    socialLinks: {
      gap: "10px",

      marginTop: "24px",
    },

    socialIcon: {
      width: "42px",
      height: "42px",
    },

    xIcon: {
      fontSize: "16px",
    },

    contactDivider: {
      marginTop: "28px",
    },

    contactText: {
      marginTop: "22px",

      fontSize: "14px",
    },

    /* =========================================
   EVERYTHING YOU GET - MOBILE
========================================= */

    /* =========================================
   FEATURE GROUP HEADER
========================================= */

    featureGroupHeader: {
      width: "100%",

      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",

      gap: "12px",

      marginBottom: "16px",
    },

    /* =========================================
   FEATURE GROUP TITLE
========================================= */

    featureGroupTitle: {
      margin: 0,

      flex: 1,

      fontSize: "16px",
      lineHeight: 1.3,
      fontWeight: 700,

      color: "#333333",

      "& span": {
        color: "#f0501e",
      },
    },

    /* =========================================
   SEE ALL / SEE LESS
========================================= */

    featureAccordionToggle: {
      display: "block",

      flexShrink: 0,

      border: "none",
      background: "transparent",

      padding: 0,

      marginTop: "2px",

      color: "#f0501e",

      fontSize: "12px",
      lineHeight: 1.3,
      fontWeight: 800,

      cursor: "pointer",

      whiteSpace: "nowrap",

      "&:focus": {
        outline: "none",
      },

      "&:focus-visible": {
        outline: "2px solid rgba(240, 80, 30, 0.35)",
        outlineOffset: "4px",
        borderRadius: "4px",
      },
    },
    /* =========================================
   FEATURE CARD
========================================= */

    featureCard: {
      width: "100%",

      flex: "none",

      display: "flex",
      alignItems: "center",

      gap: "18px",

      padding: "12px 0",

      minHeight: "145px",
    },

    /* =========================================
   REVERSE CARD
   Step 2 + Step 4
========================================= */

    featureCardReverse: {
      flexDirection: "row",
    },

    /* =========================================
   FEATURE IMAGE
========================================= */

    featureImageWrapper: {
      width: "250px",
      height: "250px",

      flexShrink: 0,

      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },

    featureImage: {
      display: "block",

      width: "100%",
      height: "100%",

      objectFit: "contain",
    },

    /* =========================================
   FEATURE CONTENT
========================================= */

    featureContent: {
      flex: 1,
      minWidth: 0,

      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      textAlign: "left",
    },

    featureCardTitle: {
      margin: "0 0 7px",

      fontSize: "15px",
      lineHeight: 1.3,
      fontWeight: 800,

      color: "#f0501e",
    },

    featureCardDescription: {
      margin: 0,

      fontSize: "12px",
      lineHeight: 1.5,
      fontWeight: 500,

      color: "#555555",
    },

    /* =========================================
   STEP ARROW
========================================= */

    /* =========================================
   COLLAPSED STATE
========================================= */

    /* =========================================
   EXPANDED STATE
========================================= */
    featureAccordionExpanded: {
      "& .featureCard": {
        display: "flex",
      },
    },

    featureAccordion: {
      width: "100%",
    },

    featureAccordionContent: {
      width: "100%",

      display: "flex",
      flexDirection: "column",
      gap: 0,

      overflowX: "visible",
      overflowY: "visible",

      paddingBottom: 0,
    },

    featureAccordionCollapsed: {
      "& $featureCard:not(:first-of-type)": {
        display: "none",
      },

      "& $mobileFeatureArrow": {
        display: "none",
      },
    },

    featureAccordionExpanded: {
      "& $featureCard": {
        display: "flex",
      },

      "& $mobileFeatureArrow": {
        display: "flex",
      },
    },

    /* =========================================
   FAQ
   Mobile
========================================== */

    faqSection: {
      padding: "32px 16px 44px",
    },

    faqContainer: {
      width: "100%",

      padding: "28px 22px 32px",

      borderRadius: "20px",
    },

    faqHeader: {
      marginBottom: "22px",

      gap: "12px",
    },

    faqTitle: {
      fontSize: "23px",
    },

    faqToggleTop: {
      fontSize: "13px",
    },

    faqQuestion: {
      fontSize: "17px",

      lineHeight: 1.4,
    },

    faqAnswer: {
      marginTop: "7px",

      fontSize: "15px",

      lineHeight: 1.55,
    },

    faqItem: {
      marginBottom: "24px",
    },

    faqToggleBottom: {
      fontSize: "13px",
    },

    faqBottomAction: {
      marginTop: "26px",
    },

    finalHostCta: {
      minHeight: "300px",

      "&:after": {
        left: "-30%",

        bottom: "-190px",

        width: "115%",

        height: "240px",
      },
    },

    finalHostCtaInner: {
      minHeight: "300px",

      padding: "48px 24px 55px",

      flexDirection: "column",

      alignItems: "center",

      justifyContent: "center",

      gap: "30px",
    },

    finalHostCtaTagline: {
      fontSize: "28px",
    },

    finalHostCtaText: {
      marginTop: "24px",

      fontSize: "20px",
    },

    finalHostCtaButton: {
      minWidth: "200px",

      padding: "15px 28px",

      fontSize: "14px",

      alignSelf: "center",
    },
    mobileFeatureArrow: {
      position: "relative",

      width: "100%",
      height: "42px",

      display: "flex",
      justifyContent: "center",
      alignItems: "center",

      margin: "4px 0 8px",

      "&::before": {
        content: '""',
        width: "0",
        height: "25px",

        borderLeft: "2px dashed #ff4e00",
      },

      "&::after": {
        content: '""',
        position: "absolute",

        bottom: "5px",

        width: "10px",
        height: "10px",

        borderRight: "2px solid #ff4e00",
        borderBottom: "2px solid #ff4e00",

        transform: "rotate(45deg)",
      },
    },
    featureAccordionBottom: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: "12px",
      paddingTop: "8px",
    },
    featureGroup: {
      scrollMarginTop: "90px",
    },
  },

  /* =========================================================
   SMALL MOBILE
   Below 480px
========================================================= */

  "@media (max-width: 480px)": {
    heroContainer: {
      gap: "32px",

      padding: "40px 18px 48px",
    },
    hostGamePage: {
      paddingTop: "60px",
    },
    heroEyebrow: {
      fontSize: "10.5px",
      letterSpacing: "1.7px",
    },

    heroTitle: {
      fontSize: "35px",
      lineHeight: 1.12,
    },

    heroTitleAccent: {
      fontSize: "44px",

      margin: "5px 0",
    },

    heroDescription: {
      fontSize: "15px",

      margin: "16px 0 24px",
    },

    hostGameButtonLarge: {
      width: "100%",

      fontSize: "14px",

      padding: "16px 28px",
    },

    heroGameCard: {
      padding: "20px 18px 18px",

      borderRadius: "16px",
    },

    sportsContainer: {
      padding: "22px 18px",
    },

    sportsList: {
      marginLeft: "-18px",
      marginRight: "-18px",

      paddingLeft: "18px",
      paddingRight: "18px",
    },

    sportsChip: {
      fontSize: "12px",

      padding: "7px 13px",
    },

    howItWorksContainer: {
      padding: "40px 16px 50px",
    },

    howItWorksTitle: {
      fontSize: "27px",

      marginBottom: "16px",
    },

    howItWorksStep: {
      minHeight: "195px",

      gap: "14px",
    },

    stepVisual: {
      width: "51%",
    },

    stepImage: {
      maxWidth: "205px",
    },

    stepContent: {
      width: "44%",
    },

    stepLabel: {
      fontSize: "12px",
    },

    stepTitle: {
      fontSize: "15px",

      marginBottom: "5px",
    },

    stepDescription: {
      fontSize: "11.5px",
      lineHeight: 1.4,
    },

    stepArrow: {
      height: "auto",

      "& img": {
        maxWidth: "95px",
      },
    },

    howItWorksCta: {
      marginTop: "20px",
    },

    hostGameButton: {
      fontSize: "13px",
      padding: "14px 26px",
    },
    stepContentWithArrow: {
      width: "44%",
      maxWidth: "195px",
    },

    stepOneArrow: {
      width: "48px",
      marginTop: "4px",
    },
    hostingGuideContainer: {
      padding: "40px 16px 48px",
    },

    hostingGuideTitle: {
      fontSize: "25px",
    },

    hostingGuideDescription: {
      fontSize: "13px",
    },

    hostingGuideList: {
      gap: "14px",

      marginLeft: "0px",
      marginRight: "-16px",

      paddingLeft: "16px",
      paddingRight: "16px",
    },

    hostingGuideCard: {
      maxWidth: "320px",
    },

    hostingGuideVideo: {
      maxWidth: "320px",
      borderRadius: "12px",
    },
    hostBenefitsContainer: {
      padding: "40px 16px 48px",
    },

    hostBenefitsTitle: {
      fontSize: "23px",

      marginBottom: "25px",
    },

    hostBenefitsGrid: {
      rowGap: "16px",
    },

    hostBenefitItem: {
      gap: "10px",

      "& p": {
        fontSize: "13px",
        lineHeight: 1.45,
      },
    },

    hostBenefitCheck: {
      width: "20px",
      height: "20px",

      borderRadius: "4px",

      fontSize: "11px",
    },

    featureHighlightsContainer: {
      padding: "40px 16px 48px",
    },

    featureHighlightsTitle: {
      fontSize: "16px",
    },

    featureHighlightsSubtitle: {
      fontSize: "14px",
    },

    featureGroupTitle: {
      fontSize: "12px",
    },

    featureScroll: {
      gap: "0px",

      marginLeft: "-16px",
      marginRight: "-16px",

      paddingLeft: "16px",
      paddingRight: "16px",
    },

    featureCard: {
      width: "100%",
      flex: "none",

      display: "flex",
      flexDirection: "row",
      alignItems: "center",

      gap: "12px",
      padding: "12px 0",

      minHeight: "145px",
    },

    featureImageWrapper: {
      width: "54%",
      maxWidth: "250px",
      height: "250px",

      flexShrink: 0,

      display: "flex",
      alignItems: "flex-start",
      justifyContent: "flex-start",
    },

    featureCardTitle: {
      fontSize: "14px",
    },

    featureCardDescription: {
      fontSize: "12px",
    },
    hostFeatureGroup: {
      padding: "16px 16px 18px",

      borderRadius: "14px",
    },

    playerFeatureGroup: {
      padding: "16px 16px 18px",

      borderRadius: "14px",
    },

    hostGameCtaSection: {
      minHeight: "180px",

      padding: "25px 16px",
    },

    hostGameCtaButton: {
      maxWidth: "250px",

      padding: "24px",

      borderRadius: "34px",

      fontSize: "14px",
    },

    formOrDivider: {
      width: "90%",

      gap: "16px",
    },

    formOrText: {
      fontSize: "18px",
    },
    appLinksContainer: {
      padding: "32px 16px 36px",
    },

    storeLinks: {
      gap: "8px",
    },

    storeBadge: {
      width: "130px",
    },

    socialLinks: {
      gap: "8px",
    },

    socialIcon: {
      width: "40px",
      height: "40px",
    },

    xIcon: {
      fontSize: "15px",
    },

    contactText: {
      fontSize: "13px",
    },
    /* =========================================
   FAQ
   Small Mobile
========================================== */

    faqSection: {
      padding: "28px 12px 40px",
    },

    faqContainer: {
      padding: "24px 18px 28px",

      borderRadius: "18px",
    },

    faqHeader: {
      marginBottom: "20px",
    },

    faqTitle: {
      fontSize: "21px",
    },

    faqToggleTop: {
      fontSize: "12px",
    },

    faqQuestion: {
      fontSize: "16px",

      lineHeight: 1.4,
    },

    faqAnswer: {
      fontSize: "14px",

      lineHeight: 1.55,
    },

    faqItem: {
      marginBottom: "22px",
    },

    faqToggleBottom: {
      fontSize: "12px",
    },

    faqBottomAction: {
      marginTop: "24px",
    },
    finalHostCta: {
      minHeight: "280px",

      "&:after": {
        left: "-35%",

        bottom: "-175px",

        width: "125%",

        height: "220px",
      },
    },

    finalHostCtaInner: {
      minHeight: "280px",

      padding: "40px 20px 48px",

      gap: "26px",
    },

    finalHostCtaTagline: {
      fontSize: "25px",
    },

    finalHostCtaText: {
      marginTop: "20px",

      fontSize: "18px",
    },

    finalHostCtaButton: {
      minWidth: "190px",

      padding: "14px 24px",

      fontSize: "13px",
    },
  },
}));
export default useStyles;
